import {
  CampaignOptions,
  MainLayoutSettings,
} from "../../../types/global.types";

export const HEADER_EMAIL_AUTOMATIC_TERMS_TEXT_AUTO_SEND =
  "By clicking below, offer details will also be sent to {email}.";

export const HEADER_EMAIL_AUTOMATIC_TERMS_TEXT_EMAIL_LINK =
  "When clicking on the email link or icon below, an email will be sent to {email}.";

export const HEADER_EMAIL_AUTOMATIC_TERMS_TEXT_COMPACT =
  "By clicking below, offer details will also be sent to {email}.";

export const COMPACT_TEMPLATE_IDENTIFIERS = [
  "template-compact-v2-pre",
  "template-compact-v2-post",
  "template-embedded-compact-v2",
];

export const isCompactTemplateIdentifier = (identifier?: string): boolean =>
  !!identifier && COMPACT_TEMPLATE_IDENTIFIERS.includes(identifier);

export const usesEmailLinkAutomaticTermsText = (
  manualEmailEntry: boolean,
  autoSendEmail: boolean,
): boolean => !manualEmailEntry && !autoSendEmail;

export const getHeaderEmailAutomaticTermsText = (
  mainLayout: MainLayoutSettings | undefined,
  campaignGeneralOptions?: CampaignOptions,
  templateIdentifier?: string,
): string => {
  if (isCompactTemplateIdentifier(templateIdentifier)) {
    return (
      mainLayout?.headerEmailAutomaticTermsTextCompact?.trim() ||
      HEADER_EMAIL_AUTOMATIC_TERMS_TEXT_COMPACT
    );
  }

  const manualEmailEntry = campaignGeneralOptions?.manualEmailEntry === true;
  const autoSendEmail = campaignGeneralOptions?.autoSendEmail === true;

  if (usesEmailLinkAutomaticTermsText(manualEmailEntry, autoSendEmail)) {
    return (
      mainLayout?.headerEmailAutomaticTermsTextEmailLink?.trim() ||
      HEADER_EMAIL_AUTOMATIC_TERMS_TEXT_EMAIL_LINK
    );
  }

  return (
    mainLayout?.headerEmailAutomaticTermsText?.trim() ||
    HEADER_EMAIL_AUTOMATIC_TERMS_TEXT_AUTO_SEND
  );
};
